<template>
  <virtual-scroll
    :data="data"
    :item-size="itemSize"
    key-prop="_rowKey"
    @change="onVirtualChange"
  >
    <el-table
      ref="table"
      :data="virtualList"
      row-key="_rowKey"
      :border="border"
      :max-height="maxHeight"
      :show-summary="showSummary"
      :summary-method="wrappedSummaryMethod"
      :highlight-current-row="true"
    >
      <div class="empty" slot="empty">
        <empty />
      </div>
      <virtual-column type="index" label="序号" width="50" align="center" fixed />
      <virtual-column
        v-for="(item, index) of tableColumnData"
        :key="index"
        :align="item.align || 'center'"
        resizable
        :width="item.width ? item.width : ''"
        :prop="item.prop"
        :fixed="item.fixed"
        :label="item.label"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="item.type === 'MONEY2'">{{ dealWithMoney2(scope.row[item.prop]) }}</span>
          <span v-else-if="item.type === 'CUSTOM'">
            <slot :name="item.prop" :scope="getSlotScope(scope)"></slot>
          </span>
          <span v-else>{{ getCellValue(scope.row, item.prop) }}</span>
        </template>
      </virtual-column>
    </el-table>
  </virtual-scroll>
</template>

<script>
import VirtualScroll, { VirtualColumn } from 'el-table-virtual-scroll';

export default {
  name: 'AlterVirtualTable',
  components: {
    VirtualScroll,
    VirtualColumn,
  },
  props: {
    tableColumnData: {
      type: Array,
      default: function () {
        return [];
      },
    },
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
    maxHeight: {
      type: Number,
      default: null,
    },
    border: {
      type: Boolean,
      default: true,
    },
    showSummary: {
      type: Boolean,
      default: false,
    },
    getElSummaries: {
      type: Function,
      default: null,
    },
    itemSize: {
      type: Number,
      default: 50,
    },
  },
  data: function () {
    return {
      virtualList: [],
    };
  },
  methods: {
    onVirtualChange: function (renderData) {
      this.virtualList = renderData;
    },
    getSlotScope: function (scope) {
      var realIndex = this.data.findIndex(function (row) {
        return row._rowKey === scope.row._rowKey;
      });
      return {
        row: scope.row,
        column: scope.column,
        $index: realIndex >= 0 ? realIndex : scope.$index,
      };
    },
    wrappedSummaryMethod: function (param) {
      if (typeof this.getElSummaries !== 'function') {
        return [];
      }
      return this.getElSummaries({
        columns: param.columns,
        data: this.data,
      });
    },
    getCellValue: function (item, path) {
      var safeValue = item[path] !== null && item[path] !== '' ? item[path] : '--';
      return safeValue;
    },
    dealWithMoney2: function (value) {
      if (!value && value !== 0 && value !== '0' && value !== 0.0 && value !== '0.0' && value !== 0.00 && value !== '0.00') {
        return '--';
      }
      return this.$options.filters.currency(
        this.$options.filters.unitMoney(value, 1),
        '￥',
        2
      );
    },
  },
};
</script>
